import { ErreurApi } from '../api/client';
import { useSignalerShopify } from '../api/hooks';
import type { CommandeListee } from '../api/types';
import { formatCourt } from '../format';
import { useToasts } from './Toasts';

/**
 * Ce que Shopify a changé après la création : annulation, remboursements.
 *
 * Rouge quand la commande était déjà chez le fournisseur et qu'il reste à le
 * prévenir — il fabriquerait et livrerait des articles que le client ne paiera
 * pas. Le bouton ne prévient personne : il constate qu'on l'a fait.
 */
export function ChangementsShopify({ commande }: { commande: CommandeListee }) {
  const signaler = useSignalerShopify();
  const { ajouter } = useToasts();
  const s = commande.shopify;
  if (!s) return null;

  const annulee = s.close;
  if (!annulee && !commande.articlesRetires.length && !s.aSignaler) return null;

  const fournisseur = commande.fournisseurs[0] ?? 'le fournisseur';
  const alerte = Boolean(s.aSignaler);

  return (
    <div
      className="fieldset"
      style={alerte ? { borderLeft: '4px solid var(--rouge)', background: 'var(--brick-soft)' } : undefined}
    >
      <h3 style={alerte ? { color: 'var(--brick)' } : undefined}>
        {annulee
          ? (s.annuleeLe ? `Annulée dans Shopify le ${formatCourt(s.annuleeLe)}` : 'Intégralement remboursée dans Shopify')
          : 'Remboursement partiel dans Shopify'}
      </h3>
      <p style={{ fontSize: 12.5, marginBottom: alerte ? 10 : 0 }}>
        {alerte
          ? `La commande était déjà chez ${fournisseur} : ${s.aSignaler}. Prévenez-le, puis indiquez-le ici.`
          : annulee
            ? 'Plus rien à commander ni à livrer : la commande est classée.'
            : 'Les articles remboursés sont retirés de la commande fournisseur.'}
        {s.motifAnnulation && ` Motif : ${s.motifAnnulation}.`}
      </p>
      {alerte && (
        <button
          type="button" className="btn pri sm" disabled={signaler.isPending}
          onClick={async () => {
            try {
              await signaler.mutateAsync({ id: commande.id });
              ajouter(`${fournisseur} prévenu.`, 'ok');
            } catch (e) {
              ajouter(e instanceof ErreurApi ? e.message : "L'enregistrement a échoué.", 'bad');
            }
          }}
        >
          {`${fournisseur} est prévenu`}
        </button>
      )}
    </div>
  );
}
